import { createReducer, on } from '@ngrx/store';
import * as LayoutActions from './layout.actions';

export interface LayoutState {
  sidebarVisible: boolean;
  headerVisible: boolean;
  footerVisible: boolean;
}

export const initialState: LayoutState = {
  sidebarVisible: true,
  headerVisible: true,
  footerVisible: true
};

export const layoutReducer = createReducer(
  initialState,
  // Sidebar actions
  on(LayoutActions.toggleSidebar, (state) => ({
    ...state,
    sidebarVisible: !state.sidebarVisible
  })),
  on(LayoutActions.showSidebar, (state) => ({
    ...state,
    sidebarVisible: true
  })),
  on(LayoutActions.hideSidebar, (state) => ({
    ...state,
    sidebarVisible: false
  })),
  
  // Header actions
  on(LayoutActions.toggleHeader, (state) => ({
    ...state,
    headerVisible: !state.headerVisible
  })),
  on(LayoutActions.showHeader, (state) => ({
    ...state,
    headerVisible: true
  })),
  on(LayoutActions.hideHeader, (state) => ({
    ...state,
    headerVisible: false
  })),
  
  // Footer actions
  on(LayoutActions.toggleFooter, (state) => ({
    ...state,
    footerVisible: !state.footerVisible
  })),
  on(LayoutActions.showFooter, (state) => ({
    ...state,
    footerVisible: true
  })),
  on(LayoutActions.hideFooter, (state) => ({
    ...state,
    footerVisible: false
  })),
  
  // Combined layout actions
  on(LayoutActions.toggleLayout, (state) => ({
    ...state,
    sidebarVisible: !state.sidebarVisible,
    headerVisible: !state.headerVisible,
    footerVisible: !state.footerVisible
  })),
  on(LayoutActions.showLayout, (state) => ({
    ...state,
    sidebarVisible: true,
    headerVisible: true,
    footerVisible: true
  })),
  on(LayoutActions.hideLayout, (state) => ({
    ...state,
    sidebarVisible: false,
    headerVisible: false,
    footerVisible: false
  })),
  on(LayoutActions.setLayoutVisibility, (state, { sidebarVisible, headerVisible, footerVisible }) => ({
    ...state,
    sidebarVisible,
    headerVisible,
    footerVisible
  }))
);
